module.exports = __webpack_public_path__ + "static/img/plaid-logo.ff686763.png";